module.exports = new __parcel__URL__("decision.5f3ba352.svg").toString();